<div *ngIf="_testStarted">
	<div class="center-content">
		<div class="big-text">{{ 'workflow.hoerverlust.started' | translate }}</div>
	</div>

	<div class="center-content">
		<div class="large-label min-width-33">
			<div class="pictograms"><img src="assets/images/icons/AudioTests.svg" alt=""/></div>
			<div>{{ currentTrack?.index+1 }}. {{ 'word.measurement' | translate }}</div>
			<div>{{ (currentTrack?.side == 'links' ? 'word.leftEar' : 'word.rightEar') | translate }}</div>
			<div *ngIf="isDevMode">{{ templateValVolume * 100 | number:'1.4-4' }}</div>
			<div *ngIf="!_delayFade && isDevMode">{{ 'workflow.wait.input' | translate }}</div>
			<div *ngIf="_delayFade && isDevMode">{{ 'workflow.input.confirm' | translate }}</div>
			<!-- Die Texte im folgenden div werden nacheinander ein- und ausgeblendet.
			Damit das nicht die Anzeige springen lässt, bestimmt ein unsichtbares Pseudoelement Höhe und Breite.-->
			<div class="position-relative">
				<div class="visibility-hidden">
					<span>{{ 'workflow.hoerverlust.risingStop' | translate }}</span><br/>
					<span>{{ 'workflow.hoerverlust.fallingStop' | translate }}</span>
				</div>
				<div class="position-absolute top-0">
					<span [hidden]="!isShowRisingVolumeText">{{ 'workflow.hoerverlust.risingStop' | translate }}</span>
					<span [hidden]="!isShowFallingVolumeText">{{ 'workflow.hoerverlust.fallingStop' | translate }}</span>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!_testStarted">
	<div class="center-content">
		<div class="big-text">{{ 'workflow.hoerverlust.ready' | translate }}</div>
	</div>
</div>

<div class="extrabuttons buttonrow replaceButtonrow">
	<div class="left-buttons"></div>
	<div class="right-buttons">
		<!--Vorwärts für Seiten einzelner Fragen-->
		<button nz-button nzType="primary" class="big-button right-one" (touchstart)="dispatchVitaReact($event)" (mousedown)="dispatchVitaReact($event)">
			{{ buttonText | translate }}
		</button>
	</div>
</div>
